import React from "react";
// Pages
import { match as matchPropTypes } from "react-router-prop-types";
import SecureRoute from "src/utils/RoleBasedSecurity/SecurityComponents/SecureRoute";
import {
  employeeEmployeePermissionRead,
  jobManagerProcessRead,
} from "src/utils/RoleBasedSecurity/permissions";
import List from "./List";
import View from "./View";

const Provider = ({ match }) => (
  <>
    <SecureRoute
      permission={employeeEmployeePermissionRead}
      exact
      path={`${match.url}`}
      // path={`${match.url}/edit/:companyId/imports-history`}
      component={List}
    />
    <SecureRoute
      permission={employeeEmployeePermissionRead}
      exact
      path={`${match.url}/list`}
      component={List}
    />
    <SecureRoute
      permission={employeeEmployeePermissionRead}
      path={`${match.url}/show/:importId`}
      exact
      heading="Podgląd importu"
      component={View}
    />
  </>
);

export default Provider;
Provider.propTypes = {
  match: matchPropTypes.isRequired,
};
